<template>
  <v-card flat>
    <v-tabs v-model="tab" class="mt-15" color="indigo accent-4" grow>
      <v-tab v-for="item in TabsName" v-if="checkPermissions(item.permission)" :key="item.name"
             class="text-info" @change="getVal(item.value)">
        <i class="fa fa-plus ml-2 text-info"></i>
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in myComponents" v-if="checkPermissions(item.permission)" :key="item.value">
        <component :is="item.name" v-if="activeComponent === item.value" :key="item.name" :de-active="false"/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import SmartLadder from "../ladder/SmartLadder";
import SmartShop from "../ladderShop/SmartShop";
import SmartLadders from "../ads/panels/ladder/smartLadder";
import EstateGradual from "../ads/panels/ladder/estateGradual.vue";
import SmartCarLadder from "../ads/panels/ladder/smartCar.vue";
import {mapGetters} from "vuex";
import ExpertSuddenlyLadders from "@/view/pages/ladderShop/expertLadder";

export default {
  name: "smartComponents",
  components: {ExpertSuddenlyLadders, SmartLadders, SmartLadder, SmartShop, EstateGradual,SmartCarLadder},
  data() {
    return {
      myComponents: [
        {name: 'smart-ladder', value: 'simpleGradual', permission: 'smart_store:active'},
        // {name: 'ExpertSuddenlyLadders', value: 'serviceGradual', permission: 'gradual_service:active'},
        {name: 'smart-shop', value: 'shopGradual', permission: 'smarts_store_store:active'},
        {name: 'smart-ladders', value: 'estateGradualAgent', permission: 'smarts_store_estate:active'},
        {name: 'SmartCarLadder', value: 'SmartCarLadder', permission: 'smarts_store_car:active'},
        // {name: 'estate-gradual', value: 'estateGradual', permission: 'smarts_store_estate:active'},
      ],
      TabsName: [
        {name: 'نردبان هوشمند شخصی', value: 'simpleGradual', permission: 'smart_store:active'},
        // {name: 'نردبان هوشمند متخصص', value: 'serviceGradual', permission: 'gradual_service:active'},
        {name: 'نردبان هوشمند فروشگاهی', value: 'shopGradual', permission: 'smarts_store_store:active'},
        {name: 'نردبان هوشمند املاک', value: 'estateGradualAgent', permission: 'smarts_store_estate:active'},
        {name: 'نردبان هوشمند نمایشگاه', value: 'SmartCarLadder', permission: 'smarts_store_car:active'},
        // {name: 'نردبان هوشمند آژانس املاک', value: 'estateGradual', permission: 'smarts_store_estate:active'},
      ],
      tab: 0,
      activeComponent: 'simpleGradual'
    }
  },
  mounted() {
    // this.checkComponent();
  },
  computed: {
    ...mapGetters(['currentAbilities'])
  },
  methods: {
    getVal(val) {
      this.activeComponent = val
    },
    checkPermissions(value) {
      return Boolean(this.currentAbilities.find((x) => x === value))
    },
    checkComponent() {
      this.myComponents.every((x) => {
        console.log(x)
        if (this.currentAbilities.find((perm) => perm === x.permission)) {
          this.activeComponent = x.value
          return false;
        }
        return true;
      })
    },
  }
}
</script>

<style scoped>

</style>